import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const ConfirmationModal = ({ open, onClose, onConfirm, title, description, secondLine, confirmButtonText, error, hideCancelButton, isWide, children }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isWide ? 800 : 400,
          maxWidth: '90%',
          maxHeight: '80vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          border: 'none', // Remove any border
          outline: 'none', // Remove focus outline
        }}
      >
        <Typography id="confirmation-modal-title" variant="h6" component="h2" gutterBottom>
          {title}
        </Typography>
        <Typography id="confirmation-modal-description" sx={{ mb: 3 }}>
          {description}
        </Typography>
        {secondLine && (
          <Typography id="confirmation-modal-secondLine" sx={{ mb: 3 }}>
            <strong>{secondLine}</strong>
          </Typography>
        )}
        {error && (
          <Typography sx={{ color: 'red', mb: 2 }}>
            {error}
          </Typography>
        )}
        {children && (
          <Box sx={{ mb: 3 }}>
            {children}
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          {!hideCancelButton && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
          >
            {confirmButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;